import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { VERIFY_SMS } from "graphql/mutations/transactions";
import { SEND_SMS } from "graphql/mutations/transactions";
import { GET_PACKAGE } from "graphql/queries/packages";
import { GET_DISTPAYMENTGATEWAYS } from "graphql/queries/paymentgateways";
import { GET_PAYMENTGATEWAYS } from "graphql/queries/paymentgateways";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { stateArray } from "utils/arrays";
import { SMSAlert } from "utils/defaults";
import { validateWholeNumber } from "utils/functions";
import { RotatingLines } from "react-loader-spinner";
import { SAlert } from "utils/functions";
import { SAText } from "utils/functions";
import { FormatPhone } from "utils/functions";
import { CustomPackageID } from "utils/defaults";
import { useHistory } from "react-router-dom";
import { useAuth } from "components/custom/authprovider";
import { getDeviceFingerprint } from "utils/functions";
import { spinnerContainerStyle } from "utils/defaults";
import useAutoLogout from "utils/autoLogout";
import { SubDirectory } from "utils/defaults";
import Logout from "./Logout";
const {
  CardHeader,
  CardBody,
  CardFooter,
  Card,
  Col,
  Row,
  FormGroup,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} = require("reactstrap");

function CustomCheckout() {
  useAutoLogout();

  const history = useHistory();
  const { wt } = useAuth();
  const { productid } = useParams();
  const iframeRef = useRef(null);
  const [step, setStep] = useState(1);
  const [apploading, setAppLoading] = useState(true);
  const [storageAmount, setStorageAmount] = useState("");
  const [paymentFrame, setPaymentFrame] = useState("");
  const [paymentdata, setPaymentData] = useState({
    firstname: "",
    lastname: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone: wt.p,
    email: "",
    paymentid: "",
    productid: productid,
    existingcustomer: false,
    referral: "",
    shortdescription: "",
    createDate: 0,
  });
  const [thePrice, setThePrice] = useState(0);
  const [packagedetails, setPackage] = useState();
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [fielderrors, setFieldError] = useState([]);

  const { loading, error, data, onError } = useQuery(GET_PACKAGE, {
    variables: { packageid: productid },
    notifyOnNetworkStatusChange: false,
    fetchPolicy: "cache-and-network",
    // fetchPolicy: 'no-cache'
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        } else if (serverError === "Account Unverified.") {
          history.push({ pathname: "/verifyaccount" });
        }
      }
    },
  });

  const {
    loading: pgloading,
    error: pgerror,
    data: pgdata,
    onError: pgonerror,
  } = useQuery(GET_PAYMENTGATEWAYS, {
    notifyOnNetworkStatusChange: false,
    fetchPolicy: "cache-and-network",
    // fetchPolicy: 'no-cache',
    // skip: productid === CustomPackageID ? true : false,
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        } else if (serverError === "Account Unverified.") {
          history.push({ pathname: "/verifyaccount" });
        }
      }
    },
  });

  // const [lookupCustomer] = useLazyQuery(LOOKUP_CUSTOMER);
  const [getDistPaymentGateways] = useLazyQuery(GET_DISTPAYMENTGATEWAYS, {
    fetchPolicy: "network-only",
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        } else if (serverError === "Account Unverified.") {
          history.push({ pathname: "/verifyaccount" });
        }
      }
    },
  });

  const [sendSMS] = useMutation(SEND_SMS, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        } else if (serverError === "Account Unverified.") {
          history.push({ pathname: "/verifyaccount" });
        }
      }
    },
  });
  const [verifySMS] = useMutation(VERIFY_SMS, {
    context: {
      headers: {
        authorization: wt && wt.wt ? `Bearer ${wt.wt}` : "", // Include the token in the request header
        "X-Device-Fingerprint": getDeviceFingerprint(), // Include the device fingerprint in a custom header
      },
    },
    onError: (errors) => {
      if (errors.networkError) {
        const serverError = errors.networkError.result.errors[0].message;
        if (serverError === "Authentication required.") {
          history.push({ pathname: "/logout" });
        } else if (serverError === "Account Unverified.") {
          history.push({ pathname: "/verifyaccount" });
        }
      }
    },
  });

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (validateWholeNumber(value)) {
      setStorageAmount(value);
      setThePrice(value);
    }
  };

  const ContinueToPhoneLookup = () => {
    let valid = true;
    setFieldError(() => []);

    if (storageAmount === undefined || storageAmount < 1) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          { field: "storage", error: "Storage Amount is required" },
        ];
      });
    }

    if (storageAmount > parseFloat(packagedetails.pertransactionlimit)) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          {
            field: "storage",
            error:
              "Max storage amount is " +
              packagedetails.pertransactionlimit +
              "GB",
          },
        ];
      });
    }

    if (storageAmount < packagedetails.minpurchase) {
      valid = false;
      setFieldError((prevState) => {
        return [
          ...prevState,
          {
            field: "storage",
            error: "Minimum storage is: " + packagedetails.minpurchase + "GB",
          },
        ];
      });
    }

    // if (process.env.REACT_APP_APIURL === "api.wowcloudnetwork.com") {
    //   if (paymentdata.referral === "" || paymentdata.referral === undefined) {
    //     valid = false;
    //     setFieldError((prevState) => {
    //       return [
    //         ...prevState,
    //         { field: "referral", error: "Referral Code is required" },
    //       ];
    //     });
    //   }
    // }

    if (valid) {
      setAppLoading(true);
      //Check Valid Referral Code and return and store payment gateways
      setPaymentData((prevState) => {
        return {
          ...prevState,
          price: parseInt(thePrice),
          storage: parseInt(storageAmount),
        };
      });

      // Get Payment Gateway info
      getDistPaymentGateways({
        variables: {
          packageid: productid,
          referralcode:
            paymentdata.referral && paymentdata.referral.trim() !== ""
              ? paymentdata.referral
              : packagedetails.defaultcode,

          price: parseInt(thePrice),
        },
      })
        .then((pginfo) => {
          if (pginfo.data) {
            //Set Payment Gateway info
            if (pginfo.data.getDistPaymentGateways.status) {
              setPaymentOptions(
                () => pginfo.data.getDistPaymentGateways.paymentgateways,
              );
              if (
                pginfo.data.getDistPaymentGateways.paymentgateways.length > 0
              ) {
                setPaymentData((prevState) => {
                  return {
                    ...prevState,
                    paymentid:
                      pginfo.data.getDistPaymentGateways.paymentgateways[0]
                        .paymentid,
                    firstname:
                      pginfo.data.getDistPaymentGateways.customer.firstname,
                    lastname:
                      pginfo.data.getDistPaymentGateways.customer.lastname,
                    address1:
                      pginfo.data.getDistPaymentGateways.customer.address1,
                    address2:
                      pginfo.data.getDistPaymentGateways.customer.address2,
                    city: pginfo.data.getDistPaymentGateways.customer.city,
                    state: pginfo.data.getDistPaymentGateways.customer.state,
                    zip: pginfo.data.getDistPaymentGateways.customer.zip,
                    phone: pginfo.data.getDistPaymentGateways.customer.phone,
                    email: pginfo.data.getDistPaymentGateways.customer.email,
                    ipaddress:
                      pginfo.data.getDistPaymentGateways.customer.ipaddress,
                    createdate:
                      pginfo.data.getDistPaymentGateways.customer.createdate,
                    referral:
                      paymentdata.referral && paymentdata.referral.trim() !== ""
                        ? paymentdata.referral
                        : packagedetails.defaultcode,
                  };
                });

                setPaymentFrame(
                  pginfo.data.getDistPaymentGateways.paymentgateways[0].path,
                );

                setStep(2);
              } else {
                //TODO: Distributor has no gateways - redirect
                SAText(
                  "Error",
                  "Promo / Referral Code is inactive",
                  "error",
                  () => {
                    setStep(1);
                  },
                );
              }
            } else {
              //ERROR FROM RESPONSE
              SAText(
                "Error",
                pginfo.data.getDistPaymentGateways.error,
                "error",
              );
            }
          } else {
            //ERROR NO GATEWAYS?
            SAText("Error", "Something bad happened", "error");
          }
        })
        .catch((err) => {
          SAText("Error", err, "error");
        })
        .finally(() => {
          // setTimeout(() => {
          setAppLoading(false);
          // }, 7000)
        });
    }
  };

  const UpdatePaymentData = (e, type = "") => {
    if (type !== "array") {
      let value = e.target.value;
      if (e.target.type === "number") {
        if (value === "") {
          value = 0;
        } else {
          value = parseInt(value);
        }
      }

      if (type === "boolean") {
        if (typeof value === "string") {
          const a = value === "true";
          value = a;
        }
      }

      setPaymentData((prevState) => {
        return { ...prevState, [e.target.name]: value };
      });
    } else {
      setPaymentData((prevState) => {
        return { ...prevState, [e.name]: e.value };
      });
    }
  };

  const CheckError = (e) => {
    if (fielderrors.length > 0) {
      const q = fielderrors.find((a) => a.field === e);
      if (q) {
        return q.error;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (paymentdata.paymentid) {
      const handleIframeMessage = (event) => {
        // if (event.origin !== process.env.REACT_APP_PAYMENT_IFRAME) return; //Child

        const { type, payload } = event.data;

        if (type === "FROM_IFRAME") {
          if (payload.action === "SendBillingData") {
            //VERIFY SMS FIRST
            sendSMS({ variables: { phone: paymentdata.phone } })
              .then((smsres) => {
                if (smsres.data.sendSMS.status) {
                  SAlert(
                    SMSAlert.title,
                    "text",
                    SMSAlert.label,
                    SMSAlert.icon,
                    (v) => {
                      verifySMS({
                        variables: { code: v, phone: paymentdata.phone },
                      })
                        .then((r2) => {
                          if (r2.data.verifySMS.status) {
                            // setAppLoading(true);
                            sendDataToIframe(paymentdata, "SendBillingData");
                          } else {
                            SAText("Error", r2.data.verifySMS.error, "error");
                            sendDataToIframe(paymentdata, "Reset");
                          }
                        })
                        .catch(() => {
                          SAText("Error", "Something went wrong.", "error");
                          sendDataToIframe(paymentdata, "Reset");
                        });
                    },
                  );
                } else {
                  SAText("Error", smsres.data.sendSMS.error, "error");
                }
              })
              .catch((err) => {
                SAText("Error", err, "error");
              })
              .finally(() => {});
          } else if (payload.action === "TransactionSuccess") {
            //Trigger the send transaction on this server to record the the transaction
            SAText("Success", "Transaction was successful", "success", () => {
              history.push({
                pathname: "/confirmation",
                state: {
                  paymentdata: paymentdata,
                  activation: JSON.parse(payload.data),
                },
              });
            });
          } else if (payload.action === "TransactionError") {
            // setAppLoading(false);
            if (
              payload.data.includes(
                "Please keep this for your reference for the future",
              )
            ) {
              SAText("Transaction Info", payload.data, "info");
            } else {
              SAText("Error", payload.data, "error");
            }
          } else if (payload.action === "CardValidationRequired") {
            //Redirect to new page
            history.push({
              pathname: "/verifycard",
              state: {
                paymentdata: paymentdata,
                paymentFrame: paymentFrame,
              },
            });
          }
        }
      };

      window.addEventListener("message", handleIframeMessage);

      return () => {
        window.removeEventListener("message", handleIframeMessage);
      };
    }
  }, [paymentdata]);

  const sendDataToIframe = (data, action) => {
    const message = {
      type: "FROM_PARENT",
      payload: { data: data, action: action },
    };
    iframeRef.current.contentWindow.postMessage(
      message,
      process.env.REACT_APP_PAYMENT_IFRAME + "/ " + paymentFrame,
    ); // Child
  };

  useEffect(() => {
    const onCompleted = (data) => {
      if (data) {
        setPackage(() => data.getPackageById);
        if (data.getPackageById.promocode != null) {
          setPaymentData((prevState) => {
            return {
              ...prevState,
              referral: data.getPackageById.promocode,
            };
          });
        }

        // if (productid !== CustomPackageID) {
        setStorageAmount(data.getPackageById.storageamount);
        setThePrice(data.getPackageById.price);
        // }
      }

      setTimeout(() => setAppLoading(false), 1000);
    };
    if (onCompleted || onError) {
      if (onCompleted && !loading && !error) {
        onCompleted(data);
      } else if (onError && !loading && error) {
        onError(error);
      }
    }
  }, [loading, data, error, onError]);

  useEffect(() => {
    const onCompleted = (pgdata) => {
      if (pgdata) {
        if (pgdata.getPaymentGateways[0].paymentid) {
          setPaymentData((prevState) => {
            return {
              ...prevState,
              paymentid: pgdata.getPaymentGateways[0].paymentid,
            };
          });

          setPaymentFrame(pgdata.getPaymentGateways[0].path);
        }

        setPaymentOptions(() => pgdata.getPaymentGateways);
      }

      setTimeout(() => setAppLoading(false), 1000);
    };
    if (onCompleted || pgonerror) {
      if (onCompleted && !pgloading && !pgerror) {
        onCompleted(pgdata);
      } else if (pgonerror && !pgloading && pgerror) {
        pgonerror(pgerror);
      }
    }
  }, [pgloading, pgdata, pgerror, pgonerror]);

  useEffect(() => {
    // if (productid) {
    //   if (productid !== CustomPackageID) {
    //     setStep(2);
    //   }
    // }
  }, []);

  // const isProdReferralRequired =
  //   process.env.REACT_APP_APIURL === "api.wowcloudnetwork.com" ||
  //   process.env.REACT_APP_APIURL === "localhost";
  const isProdReferralRequired = process.env.REACT_APP_APIURL === "localhost";

  const getStepTwoReferralValue = () => {
    if (isProdReferralRequired) {
      return paymentdata.referral;
    }

    if (paymentdata.referral === packagedetails.defaultcode) {
      return "";
    }

    return paymentdata.referral;
  };

  const renderStepOne = () => (
    <>
      <Row>
        <Col md="12">
          <p>
            WOW Cloud Network sells secure cloud storage at a name your price
            rate. $1.00 = 1GB of storage space. Please enter the amount of
            storage below.
          </p>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">
              * Storage Amount (Min: {packagedetails.minpurchase} GB):
            </label>

            <InputGroup>
              <Input
                placeholder="Storage"
                type="text"
                name="storage"
                value={storageAmount}
                onChange={handleInputChange}
                autoComplete="off"
                maxLength={10}
                className={CheckError("storage") ? "error" : ""}
              />
              <InputGroupAddon addonType="append">
                <InputGroupText>GB</InputGroupText>
              </InputGroupAddon>
            </InputGroup>

            <span className="errorMessage">{CheckError("storage") || ""}</span>
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">Price of Storage:</label>
            <Input
              readOnly
              value={
                storageAmount
                  ? `$${parseInt(storageAmount).toFixed(2)}`
                  : "$0.00"
              }
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">* Phone:</label>
            <Input readOnly value={paymentdata.phone} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">
              {isProdReferralRequired && "* "}
              Referral Code
              {isProdReferralRequired && (
                <> ({packagedetails.defaultcode} for default)</>
              )}
              :
            </label>

            <Input
              name="referral"
              value={paymentdata.referral}
              onChange={UpdatePaymentData}
              readOnly={productid !== CustomPackageID}
              className={CheckError("referral") ? "error" : ""}
            />

            <span className="errorMessage">{CheckError("referral") || ""}</span>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <FormGroup>
            <label className="subTitle">Storage Use Notes (Optional):</label>
            <Input
              placeholder="Notes"
              cols="80"
              rows="2"
              type="textarea"
              name="shortdescription"
              value={paymentdata.shortdescription}
              onChange={(e) => UpdatePaymentData(e)}
              autoComplete="off"
              maxLength={250}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col
          md="12"
          className="d-flex justify-content-center align-items-center"
        >
          <FormGroup style={{ marginLeft: "1.25em" }}>
            <Input
              style={{
                width: "25px",
                height: "25px",
              }}
              type="checkbox"
              name="agreetotermsandconditions"
              checked={true}
              isDisabled={true}
            />
            <label className="subTitle" style={{ marginLeft: "1em" }}>
              I agree to the{" "}
              <a
                href="https://wowcloudnetwork.com/legal.html?src=termsandconditions.html"
                target="_blank"
                rel="noreferrer"
              >
                Terms and Conditions
              </a>
              , including the{" "}
              <a
                href="https://wowcloudnetwork.com/purchaseterms.html"
                target="_blank"
                rel="noreferrer"
              >
                Purchase Terms
              </a>
            </label>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col
          md="12"
          className="d-flex justify-content-center align-items-center"
        >
          <FormGroup className="m-0 p-0">
            <label style={{ fontSize: ".90em" }}>
              <span>
                <a
                  href="https://wowcloudnetwork.com/legal.html?src=refundpolicy.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  Refund Policy
                </a>
              </span>
            </label>
          </FormGroup>
        </Col>
      </Row>
    </>
  );

  const renderStepTwoNormal = () => (
    <>
      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">{packagedetails.name}</label>
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">{paymentdata.storage}GB</label>{" "}
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <p>{packagedetails.longdescription}</p>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <p style={{ float: "right" }}>
            <label className="subTitle">Total: </label>
            <span>${Number(paymentdata.price).toFixed(2)}</span>{" "}
          </p>
          <hr style={{ clear: "both" }} />
        </Col>
      </Row>

      {/* CUSTOMER INFO (READ ONLY) */}
      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">* First Name:</label>
            <Input readOnly value={paymentdata.firstname} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">* Last Name:</label>
            <Input readOnly value={paymentdata.lastname} />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">* Phone:</label>
            <Input readOnly value={paymentdata.phone} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">* Email:</label>
            <Input readOnly value={paymentdata.email} />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">* Address:</label>
            <Input readOnly value={paymentdata.address1} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">Address 2:</label>
            <Input readOnly value={paymentdata.address2} />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">* City:</label>
            <Input readOnly value={paymentdata.city} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">* State:</label>
            <select className="form-control" value={paymentdata.state} disabled>
              <option value="">Select State</option>
              {stateArray.map((s) => (
                <option key={s.abbreviation} value={s.abbreviation}>
                  {s.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <label className="subTitle">* Zip:</label>
            <Input readOnly value={paymentdata.zip} />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <label className="subTitle">
              {isProdReferralRequired && "* "}
              Referral Code
              {isProdReferralRequired && (
                <> ({packagedetails.defaultcode} for default)</>
              )}
              :
            </label>

            <Input
              readOnly
              value={getStepTwoReferralValue()}
              className={CheckError("referral") ? "error" : ""}
            />

            <span className="errorMessage">{CheckError("referral") || ""}</span>
          </FormGroup>
        </Col>
      </Row>

      {/* PAYMENT OPTIONS */}
      <Row>
        <Col md="12">
          <label className="subTitle">* Select a Payment Option:</label>
          <br />
          {paymentOptions.map((pg) => (
            <img
              key={pg.paymentid}
              src={`/paymentgateways/${pg.img}`}
              className={
                (paymentdata.paymentid === pg.paymentid
                  ? "paymentactive"
                  : "") + " paymentimg"
              }
              onClick={() => {
                setPaymentData((p) => ({ ...p, paymentid: pg.paymentid }));
                setPaymentFrame(pg.path);
              }}
            />
          ))}
        </Col>
      </Row>

      {paymentFrame && (
        <Row className="squareDebit">
          <Col md="12">
            <iframe
              ref={iframeRef}
              src={`${process.env.REACT_APP_PAYMENT_IFRAME}/${paymentFrame}`}
              width="100%"
              height="320"
              title="WOWCloud Payment"
              style={{ border: 0 }}
            />
          </Col>
        </Row>
      )}
    </>
  );

  const renderFooter = () => {
    if (step === 1) {
      return (
        <CardFooter>
          <Button block color="info" onClick={ContinueToPhoneLookup}>
            Continue Checkout
          </Button>
        </CardFooter>
      );
    }

    if (step === 2) {
      return (
        <CardFooter className="text-center">
          <p className="resetLink">
            <span
              style={{ color: "red" }}
              onClick={() => window.location.reload()}
            >
              Reset Form
            </span>
          </p>
        </CardFooter>
      );
    }

    return null;
  };

  return (
    <div className="content">
      <div style={spinnerContainerStyle}>
        <RotatingLines visible={apploading} />
      </div>

      {!apploading && !packagedetails && (
        <h1 className="text-center">* Package Not Found *</h1>
      )}

      {!apploading && packagedetails && (
        <Row>
          <Col md="12">
            <Card>
              <CardHeader className="subTitle">
                WOW Cloud Network Checkout
              </CardHeader>

              <CardBody>
                {step === 1 && renderStepOne()}
                {step === 2 && renderStepTwoNormal()}
              </CardBody>

              {renderFooter()}
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
}

export default CustomCheckout;
